import {
  LOADERS,
  LOADERS_ACTIONS,
} from 'containers/AppContainer/Loader/constants';

export interface LoadingAction {
  type: string;
  loaderKey: string;
}

/* Loaders Actions */
export const startLoading = (loaderKey = LOADERS.GLOBAL): LoadingAction => ({
  type: LOADERS_ACTIONS.START,
  loaderKey,
});

export const stopLoading = (loaderKey = LOADERS.GLOBAL): LoadingAction => ({
  type: LOADERS_ACTIONS.STOP,
  loaderKey,
});
